<template>
	<div class="content">
		<!-- Navbar -->
		<nav class="navbar navbar-expand-lg navbar-absolute navbar-transparent fixed-top">
			<div class="container-fluid">
				<!-- <div class="navbar-wrapper">
					<div class="navbar-toggle d-inline">
						<button type="button" class="navbar-toggler">
							<span class="navbar-toggler-bar bar1"></span>
							<span class="navbar-toggler-bar bar2"></span>
							<span class="navbar-toggler-bar bar3"></span>
						</button>
					</div>
					<a class="navbar-brand" href="#">Login Page</a>
				</div>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
				</button>
				<div class="collapse navbar-collapse" id="navigation">
					<ul class="navbar-nav ml-auto">
						<li class="nav-item">
							
						</li>
						<li class="nav-item ">
							<a href="register.html" class="nav-link">
								<i class="tim-icons icon-laptop"></i> Register
							</a>
						</li>
						<li class="nav-item ">
							<a href="login.html" class="nav-link">
								<i class="tim-icons icon-single-02"></i> Login
							</a>
						</li>
						<li class="nav-item	active ">
							<a href="pricing.html" class="nav-link">
								<i class="tim-icons icon-coins"></i> Pricing
							</a>
						</li>
						<li class="nav-item ">
							<a href="lock.html" class="nav-link">
								<i class="tim-icons icon-lock-circle"></i> Lock
							</a>
						</li>
					</ul>
				</div> -->
			</div>
		</nav>
		<!-- <div class="modal modal-search fade" id="searchModal" tabindex="-1" role="dialog" aria-labelledby="searchModal" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<input type="text" class="form-control" id="inlineFormInputGroup" placeholder="SEARCH">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<i class="tim-icons icon-simple-remove"></i>
						</button>
					</div>
				</div>
			</div>
		</div> -->
		<!-- End Navbar -->
		<div class="wrapper wrapper-full-page">
			<div class="full-page login-page relative">
				<!--	 you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
				<div class="content flex-1 pt-5 pb-4">
					<div v-if="formType != 'register'" class="w-full text-center mb-7">
						<img class="mb-4" style="width: 20em;" :src="`${publicPath}assets/img/jfxgoldx.png`" alt="">
						<div class="">
							<span class="text-title">
								#1 Physical Gold Exchange Platform in Indonesia
							</span>
						</div>
					</div>

					<div class="flex justify-center">
						<div class="form-css">

							<!-- Login -->
							<form v-if="formType == 'login'" class="form" @submit.prevent="login">
								<div class="card">
									<div class="card-header">
										<div class="text-white text-3.5xl mb-4">Login</div>
									</div>

									<div class="card-body">
										<label for="userId" class="text-white text-xs mb-3">Email / phone number</label>
										<div class="input-group-c mb-4">
											<input type="text" class="" name="userId" placeholder="Input email / phone number"
												v-model="userId" required autofocus>
										</div>

										<label for="password" class="text-white text-xs mb-3">Password</label>
										<div class="input-group-c mb-4">
											<input v-if="!showPassword" type="password" class="" name="password"
												placeholder="Input Password" v-model="password" autocomplete="off" required>
											<input v-else type="text" class="" name="password" placeholder="Password" v-model="password"
												autocomplete="off" required>

											<div class="input-group-append-c cursor-hover-pointer" @click="tooglePassword"
												:title="showPassword ? 'Hide Password' : 'Show Password'">
												<span class="input-group-text-c">
													<IconEyeClose v-if="showPassword" :sizeMultiplier_prop="1.3" :color_prop="hexColorTheme">
													</IconEyeClose>
													<IconEyeOpen v-else :sizeMultiplier_prop="1.3" :color_prop="hexColorTheme"> </IconEyeOpen>
												</span>
											</div>
										</div>

										<label for="perantaraPerdagangan" class="text-white text-xs mb-3">Physical Gold Broker</label>
										<div class="input-group-c mb-2">
											<select class="" id="perantaraPerdagangan" v-model="perantaraPerdagangan">
												<option value="MetalGo">ABI KB - METALGO+</option>
												<option value="PosPayGold">ABI KB - PospayGold</option>
												<option value="NUNomics">ABI KB - Nunomics</option>
												<option value="BMTDigi">ABI KB - BMT Digi</option>
											</select>
										</div>

									</div>

									<div class="card-footer">
										<button type="submit" class="btn c-btn-theme btn-lg btn-block text-xs mb-4"
											:disabled="this.$store.state.status == 'loading' ? true : false">Login</button>

										<div class="text-theme text-xs cursor-hover-pointer mb-6" @click="changeFormType('forgotPassword')">
											Forgot Password
										</div>

										<hr class="bg-white mb-6">

										<div class="text-white text-xs mb-6">
											Don't Have an Account?&nbsp;
											<span class="text-theme cursor-pointer" @click="$router.push({ name: 'Register' })">
												Register Here
											</span>
										</div>

										<div class="text-center">
											<h6 v-if="response"
												:class="`${response.toLowerCase() == 'loading' ? 'color-theme-c' : 'color-red-c'} mt-2`">{{
													response }}
												<!-- <a href="#" class="link footer-link">Need Help?</a> -->
											</h6>
										</div>
									</div>
								</div>
							</form>

							<!-- Forgot Password -->
							<form v-else-if="formType == 'forgotPassword'" class="form" @submit.prevent="forgotPassword">
								<div class="card">
									<div class="card-header">
										<div class="text-white text-3.5xl mb-4">Forgot your password?</div>
									</div>

									<div class="card-body pb-0 mb-7">
										<div class="color-white-c mb-2">We will send a link to your Email</div>
										<label for="emailForgotPass" class="text-white text-xs mb-3">Email</label>
										<div class="input-group-c mb-4">
											<div class="input-group-prepend-c">
												<div class="">
													<i class="tim-icons icon-email-85"></i>
												</div>
											</div>
											<input type="text" id="emailForgotPass" class="" name="userId" placeholder="Enter your email"
												v-model="emailForgotPass" autofocus>
										</div>

										<label for="perantaraPerdagangan" class="text-white text-xs mb-3">Physical Gold Broker</label>
										<div class="input-group-c">
											<select id="perantaraPerdagangan" v-model="perantaraPerdagangan">
												<option value="MetalGo">ABI KB - METALGO+</option>
												<option value="PosPayGold">ABI KB - PospayGold</option>
												<option value="NUNomics">ABI KB - Nunomics</option>
												<option value="BMTDigi">ABI KB - BMT Digi</option>
											</select>
										</div>
									</div>

									<div class="card-footer">
										<button type="submit" class="btn c-btn-theme btn-lg btn-block mb-6"
											:disabled="forgotPasswordApiStatus == 'loading' ? true : false">Submit</button>
										<small class="form-text text-center" @click="changeFormType('login')"><span
												class="color-gold-c c-text-theme-hoverable  cursor-hover-pointer">Back to
												<b>Login</b></span></small>

										<div class="pull-left">
											<h6>
												<!-- <a href="#" class="link footer-link">Create Account</a> -->
											</h6>
										</div>
										<div class="text-center">
											<h6 v-if="responseForgotPassword" class="color-red-c">
												{{ responseForgotPassword }}
												<!-- <a href="#" class="link footer-link">Need Help?</a> -->
											</h6>
										</div>

									</div>
								</div>
							</form>

							<!-- OTP Input -->
							<form v-else-if="formType == 'inputOtp'" class="form" @submit.prevent="verifyOtp">
								<div class="card">
									<div class="card-header">
										<h1 class="card-title">OTP Verification</h1>
									</div>

									<div class="card-body pb-0 mb-7">
										<div class="color-white-c mb-6">{{ messageOnInputOtp }}</div>

										<div class="flex justify-content-between flex--gap-2 mb-6">
											<!-- <div class="bg-blue-jfx w-full">asdf</div>
											<div class="bg-blue-jfx w-full">asdf</div>
											<div class="bg-blue-jfx w-full">asdf</div> -->
											<input type="number" class="otp-input c-hide-spinner w-full" v-model="otpCodes[0]"
												@keydown="checkOnKeyDown($event, 0)">
											<input type="number" class="otp-input c-hide-spinner w-full" v-model="otpCodes[1]"
												@keydown="checkOnKeyDown($event, 1)">
											<input type="number" class="otp-input c-hide-spinner w-full" v-model="otpCodes[2]"
												@keydown="checkOnKeyDown($event, 2)">
											<input type="number" class="otp-input c-hide-spinner w-full" v-model="otpCodes[3]"
												@keydown="checkOnKeyDown($event, 3)">
											<input type="number" class="otp-input c-hide-spinner w-full" v-model="otpCodes[4]"
												@keydown="checkOnKeyDown($event, 4)">
											<input type="number" class="otp-input c-hide-spinner w-full" v-model="otpCodes[5]"
												@keydown="checkOnKeyDown($event, 5)">
										</div>

										<div v-if="timer == 'EXPIRED'">
											<div class="color-gold-c c-text-theme-hoverable cursor-hover-pointer" @click="resendOtp">Resend
												OTP</div>
										</div>
										<div v-else>
											<div class="color-white-c">Resend code in</div>
											<div class="color-theme-c">{{ timer }}</div>
										</div>
									</div>

									<div class="card-footer">
										<button type="submit" class="btn c-btn-theme btn-lg btn-block mb-6"
											:disabled="forgotPasswordApiStatus == 'loading' ? true : false">
											Lanjutkan
										</button>
									</div>
								</div>
							</form>

							<!-- Reset Password -->
							<form v-if="formType == 'resetPassword'" class="form" @submit.prevent="resetPassword">
								<div class="card">
									<div class="card-header">
										<h1 class="card-title">New Password</h1>
										<div class="">Enter a new password for your account. Make sure your password meets the following requirements</div>
									</div>
									<div class="card-body pb-0">
										<label for="newPassword" class="color-white-c">New Password</label>
										<div class="input-group-c mb-4">

											<input v-if="!showNewPassword" type="password" class="" name="newPassword"
												placeholder="Input New Password" v-model="newPassword" autocomplete="off" required>
											<input v-else type="text" class="" name="newPassword" placeholder="Password" v-model="newPassword"
												autocomplete="off" required>

											<div class="input-group-append-c cursor-hover-pointer" @click="tooglePassword('newPassword')"
												:title="showNewPassword ? 'Hide Password' : 'Show Password'">
												<span class="input-group-text-c">
													<IconEyeClose v-if="showNewPassword" :sizeMultiplier_prop="1.3" :color_prop="hexColorTheme">
													</IconEyeClose>
													<IconEyeOpen v-else :sizeMultiplier_prop="1.3" :color_prop="hexColorTheme"> </IconEyeOpen>
												</span>
											</div>
										</div>

										<label for="confirmPassword" class="color-white-c">Confirm New Password</label>
										<div class="input-group-c mb-4">

											<input v-if="!showConfirmPassword" type="password" class="" name="confirmPassword"
												placeholder="Confirm New Password" v-model="confirmPassword" autocomplete="off" required>
											<input v-else type="text" class="" name="confirmPassword" placeholder="Password"
												v-model="confirmPassword" autocomplete="off" required>

											<div class="input-group-append-c cursor-hover-pointer" @click="tooglePassword('confirmPassword')"
												:title="showConfirmPassword ? 'Hide Password' : 'Show Password'">
												<span class="input-group-text-c">
													<IconEyeClose v-if="showConfirmPassword" :sizeMultiplier_prop="1.3"> </IconEyeClose>
													<IconEyeOpen v-else :sizeMultiplier_prop="1.3"> </IconEyeOpen>
												</span>
											</div>
										</div>

										<div class="tips-password p-4">
											<div class="fw-500 mb-2 relative">
												<IconInfo2 class="mr-2" :sizeMultiplier_prop="2.2" color_prop="#279BFB" />
												Tips Password
												<div class="close-tips" @click="closeTips($event)">&#10060;&#xfe0e;</div>
											</div>

											<ul class="numbered-list">
												<li>
													<div class="number">1. </div>
													<div class="text">New password must not be the same as your old password</div>
												</li>
												<li>
													<div class="number">2.</div>
													<div class="text">Password must be at least 8 characters</div>
												</li>
												<li>
													<div class="number">3.</div>
													<div class="text">Use a combination of uppercase & lowercase letters</div>
												</li>
												<li>
													<div class="number">4.</div>
													<div class="text">Use numbers & symbols</div>
												</li>
												<li>
													<div class="number">5.</div>
													<div class="text">Password must not be too common</div>
												</li>
											</ul>
										</div>

									</div>
									<div class="card-footer">
										<button type="submit" class="btn c-btn-theme btn-lg btn-block mb-6"
											:disabled="this.$store.state.status == 'loading' ? true : false">
											Save Password
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>

				<FooterLogin />

			</div>
		</div>
	</div>
</template>

<script>
import axios from '@/api/axios.js'
import Swal from 'sweetalert2'

import FooterLogin from './components/FooterLogin.vue'

import IconEyeClose from './components/icons/IconEyeClose.vue'
import IconEyeOpen from './components/icons/IconEyeOpen.vue'
import IconUser from './components/icons/IconUser.vue'
import IconPadlock from './components/icons/IconPadlock.vue'
import IconInfo2 from './components/icons/IconInfo2.vue'
import IconArrow from './components/icons/IconArrow.vue'
import router from './router'

export default {
	name: 'Login',
	components: {
		FooterLogin,

		IconEyeClose,
		IconEyeOpen,
		IconUser,
		IconPadlock,
		IconInfo2,
		IconArrow
	},
	data() {
		return {
			publicPath: process.env.BASE_URL,
			environment: process.env.NODE_ENV,
			hexColorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),

			formType: 'login', // 'login', 'register', 'forgotPassword', 'inputOtp', 'resetPassword'

			userId: '',
			password: '',
			perantaraPerdagangan: 'MetalGo', // MetalGo, PospayGold, NUNomics, BMTDigi

			perantaraPerdanganRegister: 'AbiKomoditiBerjangka', // AbiKomoditiBerjangka

			emailForgotPass: '',
			forgotPasswordApiStatus: 'idle',
			responseForgotPassword: '',

			script: null,

			showPassword: false,
			showNewPassword: false,
			showConfirmPassword: false,


			otpCodes: ['', '', '', '', '', ''],

			newPassword: '',
			confirmPassword: '',

			validateTokenAfterOtp: '',

			messageOnInputOtp: '',
			timer: '',
		}
	},
	computed: {
		response() {
			let response = this.$store.state.status
			if (response) {
				return response
			} else {
				return null
			}
		}
	},

	created() {
		this.script = document.createElement('script')

		this.script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + this.$store.state.captchaSiteKey
		this.script.async = true

		document.body.appendChild(this.script)

		// show Google reCaptcha logo
		const reCaptchaBadge = window.document.getElementsByClassName("grecaptcha-badge")
		if (reCaptchaBadge.length > 0) {
			reCaptchaBadge[0].style.visibility = 'initial'
		}
	},

	destroyed() {
		document.body.removeChild(this.script)
	},

	methods: {
		tooglePassword(whatPassword) {
			if (whatPassword == 'newPassword') {
				this.showNewPassword = !this.showNewPassword
			} else if (whatPassword == 'confirmPassword') {
				this.showConfirmPassword = !this.showConfirmPassword
			} else {
				this.showPassword = !this.showPassword
			}
		},

		setTimerOtp() {
			// 1 minute from now expired to localstorage
			const time = new Date().getTime() + 60000
			localStorage.setItem('timerOtp', time)
		},

		startTimerOtp() {
			const expiredTime = localStorage.getItem('timerOtp')
			const now = new Date().getTime()

			if (now >= expiredTime) {
				localStorage.removeItem('timerOtp')
				this.formType = 'forgotPassword'
			} else {
				// count down every 1 second
				const x = setInterval(() => {
					const now = new Date().getTime()
					const distance = expiredTime - now
					const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
					const seconds = Math.floor((distance % (1000 * 60)) / 1000)

					this.timer = minutes + ":" + seconds

					if (distance < 0) {
						clearInterval(x)
						this.timer = "EXPIRED"
						localStorage.removeItem('timerOtp')
					}
				}, 1000)
			}
		},

		login() {
			const { userId, password, perantaraPerdagangan } = this
			this.$store.dispatch('getGeolocation')
				.then((geolocation) => {
					if (!geolocation.hasOwnProperty('latitude') || !geolocation.hasOwnProperty('longitude') || !geolocation.hasOwnProperty('city') || !geolocation.hasOwnProperty('region') || !geolocation.hasOwnProperty('country') || !geolocation.hasOwnProperty('userIP')) {
						this.$store.commit('AUTH_ERROR', "Unable to Login. Please check your connection.")
						throw ('')
					}

					this.$store.dispatch('checkFormatAuth', {
						userId,
						password
					}).then((user) => {
						this.$store.dispatch('checkUser', user).then((responseCheckUser) => {
							this.$store.dispatch('AUTH_REQUEST', [responseCheckUser.is_status, { ...user, app_name: perantaraPerdagangan }]).then(() => {
								this.$store.dispatch('setAccountInformation').then(() => {

									this.$store.commit('AUTH_CHANGE_STATUS', 'success')

									// show banner landing 
									this.$store.commit('setShowBannerLanding', true)

									// set setting to profil
									this.$store.commit('setSettingToShow_mut', 'profil')

									// set reports to Transactions
									this.$store.commit('setReportToShow_mut', 'transactions')

									const temp = JSON.parse(localStorage.getItem('nextUrl'))

									if (temp) {
										localStorage.removeItem('nextUrl')
										this.$router.push(temp)
											.then(() => {
												// console.log('then atas')
											}).catch(() => {
												// console.log('catch atas', err.config)
											})
									} else {
										this.$router.push('/')
											.then(() => {

												// console.log('then bawah')
											}).catch(() => {

												// console.log('catch bawah')
											})
									}
								}).catch(() => { this.$store.commit('itemsToRemove') })
							}).catch(() => { this.$store.commit('itemsToRemove') })
						}).catch(() => { this.$store.commit('itemsToRemove') })
					}).catch(() => { this.$store.commit('itemsToRemove') })
				}).catch(() => { this.$store.commit('itemsToRemove') })
		},

		changeFormType(formType) {
			this.formType = formType
		},

		register() {
			if (this.perantaraPerdanganRegister == 'AbiKomoditiBerjangka') {
				if (process.env.NODE_ENV == 'development') {
					window.open('https://webreg-dev-v2.abicommodity.co.id', '_blank')
				} else {
					this.$router.push('/register/abikomoditi')
				}
			}
		},

		openBantuan() {
			console.log('open bantuan', this.$refs.bantuanRegister)
			this.$refs.bantuanRegister.openModal()
		},

		forgotPassword() {
			this.forgotPasswordApiStatus = 'loading'
			this.responseForgotPassword = ''
			Swal.showLoading()

			axios({
				method: 'POST',
				url: '/v2/user/forgot_password',
				data: {
					email: this.emailForgotPass,
					app_name: this.perantaraPerdagangan
				}
			})
				.then(response => {

					Swal.close()
					// Swal.fire({
					// 	background: '#191f31',
					// 	type: 'success',
					// 	title: '<span style="color: white;">Success</span>',
					// 	html: '<span style="color: white;">' + response.data.message + '</span>',
					// }).then((result) => {
					// 	if (result.value) {
					// 		this.responseForgotPassword = ''
					// 		this.formType = 'login'
					// 	}
					// })

					this.messageOnInputOtp = response.data.data.message
					this.forgotPasswordApiStatus = 'success'
					this.formType = 'inputOtp'

					this.focusToFirstInput()

					this.setTimerOtp()
					this.startTimerOtp()
				})
				.catch(error => {
					console.log(error)
					this.forgotPasswordApiStatus = 'error'
					Swal.hideLoading()

					let title = 'Error'

					if (error.response) {
						/*
						 * The request was made and the server responded with a
						 * status code that falls out of the range of 2xx
						 */
						if (error.response.data.data.status_code == 9000) {
							title = error.response.data.data.error[0].msg.message
						} else {
							title = error.response.data.data.err_message_id
						}

					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */

						title = ' Server appears to be offline'
					} else {
						// Something happened in setting up the request and triggered an Error
					}

					this.responseForgotPassword = title

					Swal.fire({
						background: '#191f31',
						type: 'error',
						title: '<span style="color: white;">' + title + '</span>',
					})
				})
		},

		checkOnKeyDown(event, index) {
			if (event.key == 'ArrowLeft') {
				// if not first input, move to previous input
				if (index > 0) {
					event.target.previousElementSibling.focus()
				}

				return
			} else if (event.key == 'ArrowRight') {
				// if not last input, move to next input
				if (event.target.nextElementSibling != null) {
					event.target.nextElementSibling.focus()
				}

				return
			}

			// if space, do nothing
			if (event.key == ' ') {
				return
			}

			if (event.key == 'Backspace' || event.key == 'Delete') {
				// if input empty, move to previous input
				if (event.target.value == '' && index > 0) {
					this.$set(this.otpCodes, index - 1, '')
					event.target.previousElementSibling.focus()
				} else {
					this.$set(this.otpCodes, index, '')
				}

				return
			}

			event.preventDefault()

			// if not number, do nothing
			if (isNaN(event.key)) {
				return
			}

			this.$set(this.otpCodes, index, event.key)

			// if last input, do nothin
			if (event.target.nextElementSibling == null) {
				return
			}
			event.target.nextElementSibling.focus()
		},

		verifyOtp() {
			const otp = this.otpCodes.join('')

			Swal.showLoading()

			axios({
				method: 'POST',
				url: '/v2/user/verify_otp',
				data: {
					email: this.emailForgotPass,
					otp: otp,
					app_name: this.perantaraPerdagangan,
				}
			}).then(response => {
				this.validateTokenAfterOtp = response.data.data.validate_token
				this.formType = 'resetPassword'

				this.otpCodes = []

				Swal.close()
			}).catch(error => {

				let errorMessage = 'OTP Verification incorrect'

				if (error.response.data.data.status_code == 9000) {
					errorMessage = error.response.data.data.error[0].msg.message
				} else {
					errorMessage = error.response.data.data.err_message_id
				}

				Swal.hideLoading()
				Swal.fire({
					background: '#191f31',
					type: 'error',
					title: '<span style="color: white;">' + 'OTP Verification incorrect' + '</span>',
					html: '<span style="color: white;">' + errorMessage + '</span>',
					onAfterClose: () => {
						this.otpCodes = []
						this.focusToFirstInput()

						if (error.response.data.data.status_code == 9004) {
							this.formType = 'forgotPassword'
						}
					}
				})
			})
		},

		focusToFirstInput() {
			const elements = document.getElementsByClassName('otp-input')
			if (elements.length > 0) {
				elements[0].focus()
			}
		},

		async resetPassword() {
			const validation = this.validatePassword(this.newPassword)
			if (!validation.valid) {
				Swal.fire({
					background: '#191f31',
					type: 'error',
					title: '<span style="color: white;">' + 'Password tidak memenuhi ketentuan' + '</span>',
					html: '<span style="color: white;">' + validation.message + '</span>',
				})
				return
			}

			Swal.showLoading()

			const newPasswordHashed = await this.$store.dispatch('sha256', this.newPassword)
			const confirmPasswordHashed = await this.$store.dispatch('sha256', this.confirmPassword)

			axios({
				method: 'POST',
				url: '/v2/user/reset_password',
				data: {
					new_password: newPasswordHashed,
					confirm_password: confirmPasswordHashed,
					token: this.validateTokenAfterOtp,
				}
			}).then(() => {
				Swal.hideLoading()
				Swal.fire({
					background: '#191f31',
					type: 'success',
					title: '<span style="color: white;">Berhasil Disimpan</span>',
					html: '<span style="color: white;">' + 'Password baru berhasil dibuat dan disimpan. Gunakan untuk masuk kembali ke akun Anda' + '</span>',
				}).then((result) => {
					if (result.value) {
						this.newPassword = ''
						this.confirmPassword = ''
						this.responseForgotPassword = ''
						this.formType = 'login'
					}
				})

			}).catch(error => {
				Swal.hideLoading()

				let errorMessage = 'OTP Verification incorrect'
				if (error.response.data.status == 498) {
					errorMessage = error.response.data.data.message_id
				} else {
					errorMessage = error.response.data.data.err_message_id
				}

				Swal.fire({
					background: '#191f31',
					type: 'error',
					title: '<span style="color: white;">' + 'Error' + '</span>',
					html: '<span style="color: white;">' + errorMessage + '</span>',
				})
			})
		},

		resendOtp() {
			Swal.showLoading()
			axios({
				method: 'POST',
				url: '/v2/user/resend_otp',
				data: {
					email: this.emailForgotPass,
					app_name: this.perantaraPerdagangan
				}
			}).then(() => {
				Swal.close()

				this.setTimerOtp()
				this.startTimerOtp()
			}).catch((error) => {
				Swal.hideLoading()

				let errorMessage = 'OTP Verification incorrect'

				if (error.response.data.data.status_code == 9000) {
					errorMessage = error.response.data.data.error[0].msg.message
				} else {
					errorMessage = error.response.data.data.err_message_id
				}

				Swal.fire({
					background: '#191f31',
					type: 'error',
					title: '<span style="color: white;">' + errorMessage + '</span>',
					onClose: () => {
						this.formType = 'login'
					}
				})
			})
		},

		closeTips(event) {
			event.target.parentElement.parentElement.style.display = 'none'
		},

		validatePassword(input) {
			// Regular expression for the validation
			const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/

			if (regex.test(input)) {
				return { valid: true, message: "Text meets all requirements!" }
			} else {
				return { valid: false, message: "Password must be at least 8 characters, use combination of uppercase & lowercase letters, and use numbers & symbols." }
			}
		}
	}
}
</script>

<style scoped>
.login-page {
	display: flex;
	flex-direction: column;
	/* full screen height minimum */
	min-height: 100vh;
}

.input-group-prepend,
.input-group-append,
.input-group-append > * {
	background-color: white !important;
	border-color: #d1d3d7 !important;
}

.input-group-text {
	background-color: white;
}

.input-group-append > * {
	color: #9E9E9E;
	font-size: 1.1rem;
}

.lable-icon {
	font-size: 13px;
	color: #9E9E9E;
	margin-bottom: 20px;
}

.full-page > .content {
	padding-top: 60px;
	padding-bottom: 50px;
}

.text-title {
	display: inline-block;
	max-width: 40ch;
	text-align: center;
	font-size: 0.75rem;
	color: white;
	font-weight: 400;
}

.card {
	background-color: var(--grey-1-color);
	width: 26.25rem;
	max-width: 26.25rem;
}

.card.register {
	width: 45rem;
	max-width: 45rem;
}

.card > * {
	padding-right: 1.75em;
	padding-left: 1.75em;
}

.logo-css {
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(255, 255, 255, 0.5);
}

.logo-css img {
	opacity: 0.5;
}

.logo-kemendagri {
	width: 10.75em;
}

.logo-jfx {
	width: 6.5em;
}

.logo-kbi {
	width: 5.5em;
}

.logo-bei {
	width: 6.5em;
}

.logo-kmi {
	width: 6em;
}

.logo-ptpos {
	width: 3.75em;
}

.logo-lbma {
	opacity: 1;
	width: 6.75em;
}

.logo-line {
	border: 0;
	height: 2px;
	background-color: white;
	width: 50%;
	margin: 1.5em auto;
	opacity: 0.5;
}

select {
	-webkit-appearance: caret;

	/* outline: none;
	border: none;
	padding: 0 1em;
	width: calc(100% - 1em);
	color: black;
	background-color: white;
	font-size: 0.75rem; */
}

.otp-input {
	/* width: auto; */
	/* height: 2em; */
	text-align: center;
	font-size: 1.5em;
	border: 1px solid #9E9E9E;
	border-radius: 0.25em;
	padding: 0;
}

.tips-password {
	color: black;
	background-color: #dceafd;
}

.numbered-list {
	list-style: none;
	/* Remove default numbering */
	padding: 0;
	margin: 0;
	display: grid;

	/* Ensure number column depends on max content */
	grid-template-columns: max-content 1fr;

	/* Space between columns 1 character width */
	column-gap: 1ch;
}

.numbered-list li {
	color: black;
	/* Allow grid to apply consistent column width */
	display: contents;
}

.number {
	display: flex;
	justify-content: center;
	/* align-items: center; */
}

.text {}

.close-tips {
	position: absolute;
	top: 0;
	right: 0;
	cursor: pointer;
	color: black;
}

.btn-register {
	height: 2.5rem;
}
</style>
